<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M4.57,7.02C4.57,7.02,0.3,11.29,0.3,11.29C0.11,11.47,0,11.72,0,12C0,12.55,0.45,13,1,13C1.28,13,1.53,12.89,1.71,12.71C1.71,12.71,5.98,8.440000000000001,5.98,8.440000000000001C5.4,8.09,4.91,7.6,4.57,7.02C4.57,7.02,4.57,7.02,4.57,7.02ZM15,8C14.45,8,14,8.45,14,9C14,9,14,9.59,14,9.59C14,9.59,11.43,7.02,11.43,7.02C11.09,7.6,10.6,8.09,10.02,8.43C10.02,8.43,12.59,11,12.59,11C12.59,11,12,11,12,11C11.45,11,11,11.45,11,12C11,12.55,11.45,13,12,13C12,13,15,13,15,13C15.55,13,16,12.55,16,12C16,12,16,9,16,9C16,8.45,15.55,8,15,8C15,8,15,8,15,8ZM11,5C11,3.34,9.66,2,8,2C6.34,2,5,3.34,5,5C5,6.66,6.34,8,8,8C9.66,8,11,6.66,11,5C11,5,11,5,11,5ZM8,6C7.45,6,7,5.55,7,5C7,4.45,7.45,4,8,4C8.55,4,9,4.45,9,5C9,5.55,8.55,6,8,6C8,6,8,6,8,6Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Pivot',
} as DefineComponent
</script>
